import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Medidas } from 'src/app/common/models/Medidas';
import measures from 'src/assets/json/cards_measures.json';

@Injectable({
  providedIn: 'root',
})
export class BottomSheetService {

  openedBottomSheetRef: MatBottomSheetRef;

  constructor(@Inject(DOCUMENT) private document: Document,
    private deviceService: DeviceDetectorService) {

  }

  getService() {

    return this.openedBottomSheetRef;

  }

  setService(sheet: MatBottomSheetRef) {

    this.HoverRampAd(sheet != null);

    this.openedBottomSheetRef = sheet;

  }

  HoverRampAd(hover: boolean) {

    try {

      const styles = this.document.documentElement.style;

      if (hover) {

        if (this.deviceService.isMobile()) {
          styles.setProperty('--sticky-bottom', 'calc(var(--app-size-height-full) - 50px)');
        } else {
          styles.setProperty('--sticky-bottom', 'calc(var(--app-size-height-full) - 90px)');
        }
     
      } else {

        if (this.deviceService.isMobile()) {
          styles.setProperty('--sticky-bottom', '60px');
        } else {
          styles.setProperty('--sticky-bottom', '0px');
        }
      
      }

    } catch {

    }

  }

}
